import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    customOpenTradeAccount,
    OpenTradeDataResultModel,
    OTAParameter,
} from "@tSurya/Services/SubmitOpenTradeService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

// type OTAParameter = OpenTradeAccountParameter;

export interface HasOnTimeout {
    onTimeout?: () => void;
}

// The submission can outlive the gateway timeout while the back end keeps processing it.
const timeoutStatusCodes = [504, 524];

type HandlerType = CustomApiHandler<
    OTAParameter & HasOnSuccess & HasOnError<string> & HasOnTimeout,
    OpenTradeDataResultModel
>;

export const DispatchBeginSubmitOpenTrade: HandlerType = props => {
    props.dispatch({
        type: "Custom/OpenTradeData/BeginSubmitOpenTrade",
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await customOpenTradeAccount(props.apiParameter);
    } catch (error) {
        props.dispatch({
            type: "Custom/OpenTradeData/FailedSubmitOpenTrade",
        });
        if (timeoutStatusCodes.includes((error as { status?: number })?.status ?? 0)) {
            props.parameter.onTimeout?.();
            return false;
        }
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteSubmitOpenTrade: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/OpenTradeData/CompletedSubmitOpenTrade",
        result: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter?.onSuccess?.();
};

export const ClearSubmittedForm: HandlerType = props => {
    props.dispatch({
        type: "Custom/OpenTradeData/ClearSubmitOpenTrade",
    });
};

export const chain = [
    DispatchBeginSubmitOpenTrade,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteSubmitOpenTrade,
    ExecuteOnSuccessCallback,
    ClearSubmittedForm,
];

const loadSubmitOpenTradeData = createHandlerChainRunner(chain, "loadSubmitOpenTradeData");
export default loadSubmitOpenTradeData;
